/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
  GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  GetApiV1ClassroomdisciplineSharedTeachers401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedTeachers.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedTeachers } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedTeachers.ts";

export const getApiV1ClassroomdisciplineSharedTeachersQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/teachers" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedTeachersQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedTeachersQueryKey
>;

export function getApiV1ClassroomdisciplineSharedTeachersQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineSharedTeachersQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedTeachers401>,
    GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedTeachers(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de professores (Person ativas com IsTeachingStaff = true) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/teachers}
 */
export function useGetApiV1ClassroomdisciplineSharedTeachers<
  TData = GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedTeachersQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedTeachers401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedTeachersQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedTeachersQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedTeachers401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
